export const initFilterOptions = () => {
  const filterOptions = document.querySelectorAll('.filter-option');
  if (!filterOptions.length) return;

  let activeOption = null;

  const deactivateActive = () => {
    if (!activeOption) return;
    activeOption.classList.remove('active');
    activeOption = null;
  };

  const handleDocumentClick = (event) => {
    if (event.target.closest('.filter-option')) return;
    deactivateActive();
  };

  document.addEventListener('click', handleDocumentClick);

  filterOptions.forEach((option) => {
    const isMulti = option.classList.contains('filter-multi');
    let submitTimeoutId = null;
    const trigger = option.querySelector('.option-select');
    const optionItems = option.querySelectorAll('.option-item');
    const labelSpan = trigger?.querySelector('span');
    const hiddenInput = option.querySelector('.filter-option__input');
    const parentForm = option.closest('form');
    const checkboxInputs = isMulti
      ? option.querySelectorAll('input[type="checkbox"]')
      : null;

    const queueMultiSubmit = () => {
      if (!parentForm) return;
      parentForm.setAttribute('method', 'get');
      if (submitTimeoutId) {
        clearTimeout(submitTimeoutId);
      }
      submitTimeoutId = window.setTimeout(() => {
        parentForm.submit();
      }, 3000);
    };

    const initMultiGroupToggles = () => {
      if (!isMulti) return;
      const groups = option.querySelectorAll('.option-group');
      const maxVisibleItems = 6;

      groups.forEach((group) => {
        const groupItems = group.querySelectorAll('.option-item');
        if (!groupItems.length) return;

        const needsToggle = groupItems.length > maxVisibleItems;
        let viewAllButton = group.querySelector('.view-all');

        if (!needsToggle) {
          groupItems.forEach((item) => {
            item.hidden = false;
          });
          if (viewAllButton) {
            viewAllButton.remove();
          }
          return;
        }

        if (!viewAllButton) {
          viewAllButton = document.createElement('button');
          viewAllButton.type = 'button';
          viewAllButton.className = 'view-all';
          viewAllButton.textContent = 'View All';
          group.appendChild(viewAllButton);
        } else {
          viewAllButton.type = 'button';
        }

        const applyVisibility = (expanded) => {
          groupItems.forEach((item, index) => {
            const shouldShow = expanded || index < maxVisibleItems;
            item.hidden = !shouldShow;
          });
          viewAllButton.textContent = expanded ? 'Close' : 'View All';
          viewAllButton.dataset.expanded = expanded ? 'true' : 'false';
        };

        const hasCheckedBeyondLimit = Array.from(groupItems).some((item, index) => {
          if (index < maxVisibleItems) return false;
          const checkbox = item.querySelector('input[type="checkbox"]');
          return Boolean(checkbox?.checked);
        });

        applyVisibility(hasCheckedBeyondLimit);

        viewAllButton.addEventListener('click', (event) => {
          event.preventDefault();
          const isExpanded = viewAllButton.dataset.expanded === 'true';
          applyVisibility(!isExpanded);
        });
      });
    };

    const highlightCurrentSelection = () => {
      if (isMulti) {
        let hasChecked = false;
        optionItems.forEach((item) => {
          const checkbox = item.querySelector('input[type="checkbox"]');
          const isChecked = Boolean(checkbox?.checked);
          item.classList.toggle('selected', isChecked);
          item.classList.toggle('is-active', isChecked);
          if (isChecked) {
            hasChecked = true;
          }
        });
        option.classList.toggle('selected', hasChecked);
        return;
      }

      optionItems.forEach((item) => {
        item.classList.remove('selected');
        item.classList.remove('is-active');
      });
      option.classList.remove('selected');

      if (!labelSpan) return;
      const currentLabel = labelSpan.textContent.trim();
      const currentValue = labelSpan.dataset.value?.trim();
      if (!currentLabel && !currentValue) return;

      const matchedItem = Array.from(optionItems).find((item) => {
        const selectionTarget = item.querySelector('a') || item;
        const itemLabel = selectionTarget.textContent.trim();
        const itemValue = item.dataset.value?.trim();
        if (currentValue && itemValue) return itemValue === currentValue;
        return itemLabel === currentLabel;
      });

      if (!matchedItem) return;

      matchedItem.classList.add('selected');
      matchedItem.classList.add('is-active');
      option.classList.add('selected');
    };

    if (trigger) {
      trigger.addEventListener('click', () => {
        const isAlreadyActive = option.classList.contains('active');

        deactivateActive();

        if (isAlreadyActive) return;

        option.classList.add('active');
        activeOption = option;
      });
    }

    optionItems.forEach((item) => {
      item.addEventListener('click', (event) => {
        if (isMulti) return;

        if (hiddenInput) {
          event.preventDefault();
        }

        optionItems.forEach((optionItem) => {
          optionItem.classList.remove('selected');
          optionItem.classList.remove('is-active');
        });
        item.classList.add('selected');
        item.classList.add('is-active');

        const selectionTarget = item.querySelector('a') || item;
        const selectedLabel = selectionTarget.textContent.trim();
        const selectedValue = item.dataset.value?.trim();
        const previousValue = hiddenInput ? hiddenInput.value : selectedValue;

        if (labelSpan && selectedLabel) {
          labelSpan.textContent = selectedLabel;
          if (selectedValue) {
            labelSpan.dataset.value = selectedValue;
          } else {
            delete labelSpan.dataset.value;
          }
        }

        if (hiddenInput) {
          hiddenInput.value = selectedValue || '';
        }

        option.classList.add('selected');

        if (!isMulti) {
          deactivateActive();
        }

        if (parentForm && hiddenInput && previousValue !== hiddenInput.value) {
          parentForm.submit();
        }
      });
    });

    if (isMulti && checkboxInputs?.length) {
      checkboxInputs.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          highlightCurrentSelection();
          queueMultiSubmit();
        });
      });
    }

    initMultiGroupToggles();
    highlightCurrentSelection();
  });
};
